import { RootState } from '../stores/mainStore';

export const selectCustomizedFoodState = (state: RootState) => state.currentCustomizedFood;
